import {
  get_isActivehakov5bm97hw as get_isActive,
  cancel36mj9lv3a0whl as cancel,
  delay1f60wyf8ua1gc as delay,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  Dispatchers_getInstance2xomc0oxzllw9 as Dispatchers_getInstance,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  ValueTimeMark__minus_impl_f87sko6qoir9myg4l1 as ValueTimeMark__minus_impl_f87sko,
  _Duration___get_inWholeMilliseconds__impl__msfiryngn8rf3n78he as _Duration___get_inWholeMilliseconds__impl__msfiry,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration,
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  Long2qws0ah9gnpki as Long,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class ChessClock$Timer$slambda {
  constructor($isWhite, this$0, $callback) {
    this.k1c_1 = $isWhite;
    this.l1c_1 = this$0;
    this.m1c_1 = $callback;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Timer {
  constructor($outer, duration, isWhite, callback) {
    this.t1c_1 = $outer;
    this.n1c_1 = Monotonic_instance;
    this.o1c_1 = false;
    this.p1c_1 = this.n1c_1.aj();
    this.q1c_1 = this.n1c_1.aj();
    this.r1c_1 = duration;
    this.s1c_1 = null;
    var tmp = this;
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().zy_1);
    tmp.s1c_1 = launch(tmp_0, VOID, VOID, ChessClock$Timer$slambda_0(isWhite, this, callback));
  }
  u1c() {
    if (this.o1c_1) {
      this.o1c_1 = false;
      this.q1c_1 = this.n1c_1.aj();
    } else {
      this.p1c_1 = this.n1c_1.aj();
      this.o1c_1 = true;
    }
  }
  v1c(duration) {
    this.r1c_1 = duration;
  }
}
class ChessClock {
  constructor(whiteStartingTime, blackStartingTime, callback) {
    this.w1c_1 = new Timer(this, whiteStartingTime, true, callback);
    this.x1c_1 = new Timer(this, blackStartingTime, false, callback);
  }
}
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  while (get_isActive($this$launch)) {
    var string = '';
    string = $this.k1c_1 ? 'white: ' : 'black: ';
    if ($this.l1c_1.o1c_1) {
      $this.l1c_1.q1c_1 = $this.l1c_1.n1c_1.aj();
      var difference = _Duration___get_inWholeMilliseconds__impl__msfiry(ValueTimeMark__minus_impl_f87sko($this.l1c_1.q1c_1, $this.l1c_1.p1c_1));
      $this.l1c_1.r1c_1 = Duration__minus_impl_q5cfm7($this.l1c_1.r1c_1, toDuration(difference, DurationUnit_MILLISECONDS_getInstance()));
      $this.l1c_1.p1c_1 = $this.l1c_1.n1c_1.aj();
      var tmp = $this.l1c_1.r1c_1;
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration_0(0, DurationUnit_SECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(tmp, tmp$ret$0) <= 0) {
        $this.m1c_1($this.k1c_1);
        cancel($this$launch);
      }
    }
    var tmp_0 = delay(new Long(100, 0), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function ChessClock$Timer$slambda_0($isWhite, this$0, $callback) {
  var i = new ChessClock$Timer$slambda($isWhite, this$0, $callback);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
//region block: post-declaration
initMetadataForLambda(ChessClock$Timer$slambda, VOID, VOID, [1]);
initMetadataForClass(Timer, 'Timer');
initMetadataForClass(ChessClock, 'ChessClock');
//endregion
//region block: exports
export {
  ChessClock as ChessClock3fxe921ed7qxr,
};
//endregion
